class LocalizationFormComponent extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.languageInput = null;
    this.countryInput = null;
    this.countryInputItems = null;

    this.handleCountryClick = this.handleCountryClick.bind(this);
    this.handleLanguageChange = this.changeLanguage.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.languageInput = this.querySelector('[data-ref="language-input"]');
    this.countryInput = this.querySelector('[data-ref="country-input"]');
    this.countryInputItems = this.querySelectorAll('[data-ref="country-input-item"]');

    // On écoute les changements de pays
    this.countryInputItems.forEach((countryInputItem) => {
      countryInputItem.addEventListener('click', this.handleCountryClick);
    });

    // On écoute les changements de langue
    this.languageInput?.addEventListener('change', this.handleLanguageChange);
  }

  disconnectedCallback() {
    this.countryInputItems.forEach((countryInputItem) => {
      countryInputItem.removeEventListener('click', this.handleCountryClick);
    });

    this.languageInput?.removeEventListener('change', this.handleLanguageChange);
  }

  handleCountryClick(event) {
    const countryInputItem = event.currentTarget;
    this.selectCountry(countryInputItem.dataset.value, event);
  }

  selectCountry = (countryName, event) => {
    event.preventDefault();

    this.countryInput.value = countryName;
    this.form?.submit();
  };

  changeLanguage(event) {
    const value = event.target instanceof HTMLSelectElement ? event.target.value : null;

    if (value) {
      this.languageInput.value = value;
      this.form?.submit();
    }
  }
}

if (!customElements.get('localization-form-component')) {
  customElements.define('localization-form-component', LocalizationFormComponent);
}
